import React, { useState } from "react";
import Link from "components/Link";
import Layout from "app/(others)/layout";

const CardFb = ({ className = "h-full", post }) => {
  const { href, date, titre, image, message } = post;
  const [isHover, setIsHover] = useState(false);

  return (
    <a href={href}>
      <Layout>
        <div
          className={`nc-Card10V2 relative flex flex-col ${className}`}
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
        >
       

          {date}

          <div className="block group rounded-3xl flex-shrink-0 relative w-full aspect-w-16 aspect-h-12 sm:aspect-h-9 overflow-hidden z-0">
            <Link href={href} className="absolute inset-0">
              <img
                className="w-full h-full object-cover"
                src={image}
                alt={titre || post.message || "image"}
              />
            </Link>
          </div>

          <div className="articleDescription">
            {message}
          </div>
        </div>
      </Layout>
    </a>
  );
};

export default CardFb;
